exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hoverable {\n\tposition: relative;\n\tdisplay: block;\n}\n.hoverable:hover .hoverable-overlay {\n\talign-items: center;\n\tbackground-color: rgba(0,0,0,.3);\n\tcolor: #fff;\n\tdisplay: flex;\n\theight: 100%;\n\tjustify-content: center;\n\tposition: absolute;\n\ttext-align: center;\n\twidth: 100%;\n}\n.hoverable-overlay {\n\tdisplay: none;\n}\n.bg-loading {\n\tbackground-color: rgba(0,0,0,.3);\n}\n\n", ""]);

// exports
